import axios from 'axios'
import store from '@/store'
import { TOKEN_KEY, TOKEN_TYPE } from './config'

let isAlreadyFetchingAccessToken = false;
let subscribers = [];

async function responseError(error) {
    console.error('axios response err',error)
    if (error.response && error.response.status === 401) {
        let refreshRes = await getRefreshToken(error)
        return new Promise((reslove, reject) => {
          if(refreshRes.status == 200) {
              reslove(refreshRes.data)
          } else {
              reject(refreshRes)
          }
        });
    }
    return Promise.reject(error);
}

async function getRefreshToken(error) {
    const { config } = error;
    const originalRequestConfig = config
    let refreshToken = store.state.refreshToken
    console.log('refreshtoken', refreshToken)
    if(!refreshToken) {
        return Promise.reject(error);
    }

    const retryOriginalRequest = new Promise(resolve => {
        /* We need to add the request retry to the queue
        since there another request that already attempt to
        refresh the token */
          addSubscriber(access_token => {
            originalRequestConfig.headers[TOKEN_KEY] =  `${TOKEN_TYPE}${access_token}`;
            console.log('retry', originalRequestConfig)
            resolve(axios(originalRequestConfig));
          });
        });
    
    if(!isAlreadyFetchingAccessToken) {
        const responseRefresh = await refreshTokenService(refreshToken)
        console.log('refresh token',responseRefresh)
        if(responseRefresh.status == 401) {
            console.log('logout')
            store.dispatch('logout')
            return Promise.reject(error);
        }
        
        if(responseRefresh.status !== 200) {
            return Promise.reject(error);
        } 
        const newToken = responseRefresh.data.data.accessToken
        console.log('token refreshd', newToken)
       store.dispatch('updateToken',newToken)
        isAlreadyFetchingAccessToken = false;
        onAccessTokenFetched(newToken)
    }
    return retryOriginalRequest

}

function onAccessTokenFetched(access_token) {
    console.log('onaccess token fetched',subscribers)
	// When the refresh is successful, we start retrying the requests one by one and empty the queue
  subscribers.forEach(callback => callback(access_token));
  subscribers = [];
}
function addSubscriber(callback) {
    subscribers.push(callback);
  }

function addInceptor(service) {
    // request interceptor
    service.interceptors.request.use(config => {
       let token =  store.state.token
       let userData = store.state.userData
       console.log('token',token)
       console.log('userdata',userData)
       if(userData && 'lastHouseStatus' in userData && 'houseId' in userData.lastHouseStatus && 'estateId' in userData.lastHouseStatus) {

        config.headers['houseId'] =  store.state.userData.lastHouseStatus.houseId
        config.headers['estateid'] = store.state.userData.lastHouseStatus.estateId
       }
        
        if (token != '') {
            config.headers[TOKEN_KEY] = `${TOKEN_TYPE}${token}`
        }
        return config
    },responseError)

     // response interceptor
     service.interceptors.response.use((response) => {
        return response.data
    }, responseError)

    return service
}

function refreshTokenService(refreshToken) {
    let service = axios.create({
        baseURL: process.env.VUE_APP_URL_ACCOUNT
    })
    return service({
        url: 'token/refresh',
        method: 'post',
        data: {
            refreshToken
        }
    })
}

function createAccountService() {
    let service = axios.create({
        baseURL: process.env.VUE_APP_URL_ACCOUNT
    })

    return addInceptor(service)
}

function createProductService() {
    console.log('product service')
    let service = axios.create({
        baseURL: process.env.VUE_APP_URL_PRODUCT
    })

    return addInceptor(service)
}

const accountService = createAccountService()
const productService = createProductService()

export { accountService, productService }